import { render, staticRenderFns } from "./StatisticPage2.vue?vue&type=template&id=c9c4c2be&scoped=true"
import script from "./StatisticPage2.vue?vue&type=script&lang=js"
export * from "./StatisticPage2.vue?vue&type=script&lang=js"
import style0 from "./StatisticPage2.vue?vue&type=style&index=0&id=c9c4c2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c4c2be",
  null
  
)

export default component.exports